// extracted by mini-css-extract-plugin
module.exports = {"memberItemContainer":"CommitteeMemberItem_memberItemContainer__oBytS","memberImage":"CommitteeMemberItem_memberImage__vFaoA","memberSince":"CommitteeMemberItem_memberSince__2rPpI"};